module.exports = __webpack_public_path__ + "static/media/isometric.3414e66f.jpg";